module.exports = __webpack_public_path__ + "img/sub28.6618a075.jpg";